import { Moment } from "moment";

const isWorkDay = (date: Moment): boolean => {
  const day = date.day();
  return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
};

/**
 * Adds `days` workdays to `startDate`. 
 * If days = 1, ends on the start day itself (or next workday if starting on a weekend).
 */
export const addWorkDays = (startDate: Moment, days: number): Moment => {
  if (days <= 0) return startDate.clone();
  const current = startDate.clone().startOf("day");
  
  while (!isWorkDay(current)) {
    current.add(1, "day");
  }

  let remaining = days - 1;
  while (remaining > 0) {
    current.add(1, "day");
    if (isWorkDay(current)) {
      remaining -= 1;
    }
  }
  return current;
};

/**
 * Subtracts `days` workdays from `endDate`.
 * If days = 1, starts on the end day itself (or previous workday if ending on a weekend).
 */
export const subtractWorkDays = (endDate: Moment, days: number): Moment => {
  if (days <= 0) return endDate.clone();
  const current = endDate.clone().startOf("day");

  while (!isWorkDay(current)) {
    current.subtract(1, "day");
  }

  let remaining = days - 1;
  while (remaining > 0) {
    current.subtract(1, "day");
    if (isWorkDay(current)) {
      remaining -= 1;
    }
  }
  return current;
};
